module.exports = __webpack_public_path__ + "img/knu2_gallery10.98d4459b.jpg";